import { Component, OnInit, Input, Renderer2, ElementRef  } from '@angular/core';
import { DomSanitizer, SafeHtml} from '@angular/platform-browser';
import { Router } from '@angular/router';

import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';


@Component({
  selector: 'app-template-a',
  standalone: true,
  imports: [ MatButtonModule, MatProgressSpinnerModule, MatCardModule, MatIconModule],
  templateUrl: './template-a.component.html',
  styleUrl: './template-a.component.scss'
})
export class TemplateAComponent {

  public _templateData :any = null;


  @Input()
  set templateData(value : any) {
    this._templateData = value
    this.redraw()
  }

  @Input() canEdit :boolean = false
  isEditable = false

  safeHtmlBody: any;

  constructor(private sanitizer: DomSanitizer, private router: Router, private renderer: Renderer2, private el: ElementRef){

  }

  redraw() {
    this.safeHtmlBody = this.sanitizer.bypassSecurityTrustHtml(this._templateData.bodyText)
    if (this._templateData.backgroundImage && this._templateData.backgroundImage.length > 1) {
      this.renderer.setStyle(this.el.nativeElement.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector('div'), 'background-image', `url(${this._templateData.backgroundImage})`);
    } else {
      this.renderer.setStyle(this.el.nativeElement.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector('div'), 'background-image', `url(${''})`);
    }
  }

  onButtonClick(url :string){
    this.router.navigate([url])
  }

  onMoreButtonClick( insert : any){
    if (insert.more){
      delete insert.more
    } else {
      insert['more'] = true
    }
  }

}
